import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faFileAlt, faChartBar } from '@fortawesome/free-solid-svg-icons';
import Layout from '../../../../app/Layout';
import HeaderContent from '../../General/HeaderContent';
import Breadcrumb from '../../General/Breadcrumb';
import SpinnerLoading from '../../../components/Spinners/SpinnerLoading';
import { obtenerEventosTutor } from '../../../../actions/tutoresActions';
import { obtenerEncuestasReportesTutor } from '../../../../actions/encuestasAction';

const TABS = [
  { key: 'progreso',  label: 'Progreso',           path: '/tutor/espacio-trabajo',          icon: faChartBar       },
  { key: 'protocolo', label: 'Protocolo',           path: '/tutor/espacio-trabajo/protocolo', icon: faClipboardList  },
  { key: 'reporte',   label: 'Reporte de sesión',   path: '/tutor/espacio-trabajo/reporte',   icon: faFileAlt        },
];

const tabDesdeRuta = (pathname) => {
  if (pathname.endsWith('/protocolo')) return 'protocolo';
  if (pathname.endsWith('/reporte'))   return 'reporte';
  return 'progreso';
};

const EstadoBadge = ({ estado }) => {
  const map = {
    enviado:   { label: 'Enviado',   variant: 'success'   },
    borrador:  { label: 'Borrador',  variant: 'warning'   },
    pendiente: { label: 'Pendiente', variant: 'secondary' },
  };
  const cfg = map[estado] || map.pendiente;
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
};

const EspacioTrabajo = () => {
  const dispatch  = useDispatch();
  const location  = useLocation();
  const tabActiva = tabDesdeRuta(location.pathname);

  const { usuario }                       = useSelector(s => s.usuario);
  const { eventosTutor, loading: loadEv } = useSelector(s => s.tutores);
  const { reportesTutor, loading: loadSe } = useSelector(s => s.encuestas);

  const eventos = eventosTutor?.eventos_tutor || [];
  const [proyectoSel, setProyectoSel] = useState(null);

  useEffect(() => {
    if (usuario.id_empleado) {
      dispatch(obtenerEventosTutor(usuario.id_empleado));
    }
  }, [usuario.id_empleado]);

  useEffect(() => {
    if (eventos.length === 1) setProyectoSel(eventos[0]);
  }, [eventos]);

  useEffect(() => {
    if (proyectoSel) {
      dispatch(obtenerEncuestasReportesTutor(proyectoSel.id_tutor_proyecto));
    }
  }, [proyectoSel]);

  const renderTabProgreso = () => (
    <div className="table-responsive">
      <table className="table table-bordered table-hover">
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Sesión</th>
            <th>Fecha</th>
            <th className="text-center">Encuesta</th>
            <th className="text-center">Protocolo</th>
            <th className="text-center">Reporte sesión</th>
          </tr>
        </thead>
        <tbody>
          {reportesTutor.length === 0 ? (
            <tr><td colSpan={6} className="text-center text-muted">No hay sesiones</td></tr>
          ) : (
            reportesTutor.map((s, i) => (
              <tr key={s.id_sesion || i}>
                <td className="text-center">{i + 1}</td>
                <td>{s.nombre_sesion || `Sesión ${s.id_sesion}`}</td>
                <td className="text-center">{s.fecha || '—'}</td>
                <td className="text-center">
                  <EstadoBadge estado={s.id_tp_estado_formulario === '2' ? 'enviado' : 'pendiente'} />
                </td>
                <td className="text-center">
                  <Link to={`/tutor/sesion/${s.id_sesion}/protocolo`} className="btn btn-info btn-xs">
                    <FontAwesomeIcon icon={faClipboardList} className="mr-1" />
                    Ver
                  </Link>
                </td>
                <td className="text-center">
                  <Link to={`/tutor/sesion/${s.id_sesion}/reporte`} className="btn btn-primary btn-xs">
                    <FontAwesomeIcon icon={faFileAlt} className="mr-1" />
                    Ver
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTabProtocolo = () => (
    <div className="table-responsive">
      <table className="table table-bordered table-hover">
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Sesión</th>
            <th>Fecha</th>
            <th className="text-center">Acción</th>
          </tr>
        </thead>
        <tbody>
          {reportesTutor.length === 0 ? (
            <tr><td colSpan={4} className="text-center text-muted">No hay sesiones</td></tr>
          ) : (
            reportesTutor.map((s, i) => (
              <tr key={s.id_sesion || i}>
                <td className="text-center">{i + 1}</td>
                <td>{s.nombre_sesion || `Sesión ${s.id_sesion}`}</td>
                <td className="text-center">{s.fecha || '—'}</td>
                <td className="text-center">
                  <Link
                    to={`/tutor/sesion/${s.id_sesion}/protocolo`}
                    className="btn btn-info btn-sm"
                  >
                    <FontAwesomeIcon icon={faClipboardList} className="mr-1" />
                    Abrir protocolo
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  const renderTabReporte = () => (
    <div className="table-responsive">
      <table className="table table-bordered table-hover">
        <thead className="thead-light">
          <tr>
            <th>#</th>
            <th>Sesión</th>
            <th>Fecha</th>
            <th className="text-center">Acción</th>
          </tr>
        </thead>
        <tbody>
          {reportesTutor.length === 0 ? (
            <tr><td colSpan={4} className="text-center text-muted">No hay sesiones</td></tr>
          ) : (
            reportesTutor.map((s, i) => (
              <tr key={s.id_sesion || i}>
                <td className="text-center">{i + 1}</td>
                <td>{s.nombre_sesion || `Sesión ${s.id_sesion}`}</td>
                <td className="text-center">{s.fecha || '—'}</td>
                <td className="text-center">
                  <Link
                    to={`/tutor/sesion/${s.id_sesion}/reporte`}
                    className="btn btn-primary btn-sm"
                  >
                    <FontAwesomeIcon icon={faFileAlt} className="mr-1" />
                    Abrir reporte
                  </Link>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <Layout>
      <HeaderContent title="Espacio de Trabajo" icon="briefcase" />
      <Breadcrumb link={[
        { url: '/inicio', nombre: 'Inicio', icon: 'fas fa-home' },
        { url: '',        nombre: 'Espacio de Trabajo' },
      ]} />

      {/* Selector de proyecto */}
      <div className="box p-3 mb-3">
        <div className="row align-items-end">
          <div className="col-md-4">
            <label><strong>Proyecto</strong></label>
            {loadEv ? (
              <p className="text-muted">Cargando proyectos...</p>
            ) : (
              <select
                className="form-control form-control-sm"
                value={proyectoSel?.id_tutor_proyecto || ''}
                onChange={e => {
                  const ev = eventos.find(ev => String(ev.id_tutor_proyecto) === e.target.value);
                  setProyectoSel(ev || null);
                }}
              >
                <option value="">— Seleccionar proyecto —</option>
                {eventos.map(ev => (
                  <option key={ev.id_tutor_proyecto} value={ev.id_tutor_proyecto}>
                    {ev.nombre_proyecto || `Proyecto ${ev.id_tutor_proyecto}`}
                  </option>
                ))}
              </select>
            )}
          </div>
          {proyectoSel && (
            <div className="col-md-4">
              <small className="text-muted">
                {reportesTutor.length} sesión(es) cargadas
              </small>
            </div>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div className="box">
        <div className="box-header p-0">
          <ul className="nav nav-tabs" style={{ borderBottom: 'none', paddingLeft: 16 }}>
            {TABS.map(tab => (
              <li key={tab.key} className="nav-item">
                <Link
                  to={tab.path}
                  className={`nav-link ${tabActiva === tab.key ? 'active' : ''}`}
                >
                  <FontAwesomeIcon icon={tab.icon} className="mr-1" />
                  {tab.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="box-body">
          {!proyectoSel ? (
            <p className="text-muted text-center py-3">Selecciona un proyecto para ver las sesiones</p>
          ) : loadSe ? (
            <SpinnerLoading loading={true} />
          ) : (
            <>
              {tabActiva === 'progreso'  && renderTabProgreso()}
              {tabActiva === 'protocolo' && renderTabProtocolo()}
              {tabActiva === 'reporte'   && renderTabReporte()}
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default EspacioTrabajo;
